<template>
    <select class="c-select" :id="keyName" :name="keyName" v-model="value" @change="handleSelect">
      <option v-for="option in selectArray" :key="option" :value="option">{{ option }}</option>
    </select>
</template>

<script>
export default {
  data() {
    return {
      value: '00',
    }
  },
  props: {
    keyName: {
      type: String,
      required: true,
    },
    selectArray: {
      type: Array,
      required: true,
    },
    inputValue: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      required: false,
    }
  },
  mounted() {
    this.value = this.inputValue
  },
  methods: {
    handleSelect() {
      this.$emit('select-input', this.value, this.type)
    },
  },
}
</script>